import React, { Component } from 'react';
import './loanСonditions.scss';

class LoanСonditions extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }

    isPartnerCommission(typeID) {
        const partnerCommissionID = 2;
        return typeID === partnerCommissionID;
    }

    render() {
        return (
            <div className="LoanСonditions">
                <div className="container">
                    <div className="row ctm-one">
                        <div className="col-11 col-sm-10 col-md-7 m-auto">
                            <div className="ctm-title">
                                Условия рассрочки
                            </div>
                            <div className="ctm-text">
                                В некоторых случаях Алиф имеет право увеличить сумму предоплаты или потребовать
                                поручителя.
                            </div>
                        </div>
                    </div>
                    <div className="row ctm-two">
                        <div className="col-11 col-sm-10 col-md-7 m-auto">
                            <div className="row ctm-example-title">
                                <div className="col-4">
                                    <span>
                                        Срок
                                    </span>
                                </div>
                                <div className="col-4">
                                    <span>
                                        Предоплата
                                    </span>
                                </div>
                                <div className="col-4">
                                    <span>
                                        Наценка
                                    </span>
                                </div>
                            </div>
                            {
                                this.props.params && this.props.params.map((item, index) => (
                                    <div className="row ctm-example-text" key={index}>
                                        <div className="col-4">
                                            <span className="mr-1">
                                                {item.period}
                                            </span>
                                            <span>
                                                мес.
                                            </span>
                                        </div>
                                        <div className="col-4">
                                            <span>
                                                {item.prepay}
                                            </span>
                                            <span>
                                                %
                                            </span>
                                        </div>
                                        <div className="col-4">
                                            <span>
                                                {item.overpayment}
                                            </span>
                                            <span className="percent">
                                                %
                                                {
                                                    this.isPartnerCommission(item.typeID)
                                                    &&
                                                    <span>
                                                        *
                                                    </span>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="mt-4 text-center">
                                * Для покупки товара или услуги с комиссией, 
                                получите накладную и обратитесь в ближайшую точку обслуживания «Алиф Банк»
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoanСonditions;